import { createColumnHelper } from '@tanstack/table-core';
import { WebhookHistory } from '../webhooks.models';

const columnHelper = createColumnHelper<WebhookHistory>();

export const getWebhookHistoryColumnDefs = () => [
  columnHelper.accessor((row) => row.webhookId, {
    id: 'WebhookId',
    header: () => 'Name',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.webhookType, {
    id: 'WebhookType',
    header: () => 'Webhook Type',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.responseHttpStatusCode, {
    id: 'responseHttpStatusCode',
    header: () => 'Response Status Code',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.responseDescription, {
    id: 'responseDescription',
    header: () => 'Response Description',
    enableColumnFilter: false,
    cell: (info) => (
      <div title={info.getValue()} className="text-sm truncate truncate">
        {info.getValue()}
      </div>
    )
  }),
  columnHelper.accessor((row) => row.lastProcessedDateTimeISO, {
    id: 'lastProcessedDateTimeISO',
    header: () => 'Last Processed Date',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.payloadId, {
    id: 'payloadId',
    header: () => 'Payload Id',
    enableColumnFilter: false,
    cell: (info) => (
      <div className="text-sm truncate truncate">{info.getValue()}</div>
    )
  })
];
